// extracted by mini-css-extract-plugin
export default {"sidebar":"Sidebar_sidebar__+brs5","title":"Sidebar_title__TU32m","menu":"Sidebar_menu__sxzhT","menuItem":"Sidebar_menuItem__wRwSO","active":"Sidebar_active__78axB"};